module.exports = __webpack_public_path__ + "static/media/table_background_3.2fc2b52d.jpg";